import styled from '@emotion/styled';

import { Status } from '../../../UI/Status/Status';

export const StyledStatus = styled(Status)`
  margin-top: 0.31rem;
  margin-bottom: 0.31rem;
`;
